let stages = {
    Base: {
        stages: [
            "SigningContractAgreementTermination",
            "SigningExtensionAgreement",
            "SigningAct",
            "ContractTerminated",
            "ViolationSigningDeadlineRejection"
        ],
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRemarks",
            "viewRemarksNavigation",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewDeadlineExtendForm",
            "viewContractTerminationAgreement",

            // letter access
            "actionCustomLetter"
        ]
    },

    ApplicationFormationCreating: {
        page: '/draft',
        icon: 'fa fa-pencil',
        permissionKeys: [
            'viewDefaultRequest',
            'editDefaultRequest',
            'editHasLinkedRequest',
            'viewRequestNavigation',
            'viewSaveButton',
            'viewFormNavigation',
            'viewDeleteRequestBtn',
            'viewLinkedRequestNavigation',
            'viewRemarksCENavigation',
            'viewRemarksCE',
            'viewRemarksCRNavigation',
            'viewRemarksCR',
            'viewTerminateRequestButton',
            'viewConclusionRequest',
        ],
    },
    ApplicationFormationFilling: {
        page: '/draft',
        icon: 'fa fa-pencil',
        anchor: 'declarer',
        permissionKeys: [
            'viewDefaultRequest',
            'editDefaultRequest',
            'editHasLinkedRequest',
            'viewRequestNavigation',
            'viewSaveButton',
            'viewFormNavigation',
            'viewDeleteRequestBtn',
            'viewLinkedRequestNavigation',
            'viewRemarksCENavigation',
            'viewRemarksCE',
            'viewRemarksCRNavigation',
            'viewConclusionRequest',
            'viewRemarksCR',
            'viewTerminateRequestButton',
            'editMRA',
        ],
    },
    ApplicationFormationDocuments: {
        page: '/draft',
        icon: 'fa fa-upload-o',
        anchor: 'uploads',
        permissionKeys: [
            'viewDefaultRequest',
            'viewDocument',
            'editDocument',
            'editMRA',
            'signDocument',
            'viewRequestNavigation',
            'viewDocumentNavigation',
            'viewFormNavigation',
            'viewMultiFileUpload',
            'viewDeleteRequestBtn',
            'viewLinkedRequestNavigation',
            'viewRemarksCENavigation',
            'viewRemarksCE',
            'viewRemarksCRNavigation',
            'viewConclusionRequest',
            'viewRemarksCR',
            'viewTerminateRequestButton'
        ],
    },
    ApplicationFormationPrinting: {
        page: '/draft',
        icon: 'fa fa-check-square-o',
        anchor: 'documentsPrintedForm',
        permissionKeys: [
            'viewDefaultRequest',
            'viewDocument',
            'viewPrintForm',
            'signPrintForm',
            'viewRequestNavigation',
            'viewDocumentNavigation',
            'viewFormNavigation',
            'interactFormNavigation',
            'viewDeleteRequestBtn',
            'viewLinkedRequestNavigation',
            'viewRemarksCENavigation',
            'viewRemarksCE',
            'viewRemarksCRNavigation',
            'viewConclusionRequest',
            'viewRemarksCR',
        ],
    },

    DraftCreating: {
        page: "",
        icon: "",
        permissionKeys: []
    },
    DraftFilling: {
        page: "/draft",
        icon: "fa fa-pencil",
        permissionKeys: [
            "viewDefaultRequest",
            "editDefaultRequest",
            "editHasLinkedRequest",
            "viewRequestNavigation",
            "viewSaveButton",
            "viewFormNavigation",
            "viewDeleteRequestBtn",
            "viewLinkedRequestNavigation",
            "editMRA",
        ]
    },
    DraftDocuments: {
        page: "/draft",
        icon: "fa fa-upload-o",
        anchor: "uploads",
        permissionKeys: [
            "viewDefaultRequest",
            "viewDocument",
            "editDocument",
            "editMRA",
            "signDocument",
            "viewRequestNavigation",
            "viewDocumentNavigation",
            "viewFormNavigation",
            "viewMultiFileUpload",
            "viewDeleteRequestBtn",
            "viewLinkedRequestNavigation"
        ]
    },
    DraftPrinting: {
        page: "/draft",
        icon: "fa fa-check-square-o",
        anchor: "documentsPrintedForm",
        permissionKeys: [
            "viewDefaultRequest",
            "viewDocument",
            "viewPrintForm",
            "signPrintForm",
            "viewRequestNavigation",
            "viewDocumentNavigation",
            "viewFormNavigation",
            "interactFormNavigation",
            "viewDeleteRequestBtn",
            "viewLinkedRequestNavigation"
        ]
    },
    DraftSelectLinkedRequest: {
        page: "/draft",
        icon: "fa fa-check-square-o",
        anchor: "linkedRequestForm",
        permissionKeys: [
            "viewDefaultRequest",
            "viewDocument",
            "viewPrintForm",
            "viewRequestNavigation",
            "viewDocumentNavigation",
            "viewFormNavigation",
            "interactFormNavigation",
            "viewDeleteRequestBtn",
            "viewLinkedRequestNavigation",
            "interactLinkedRequestNavigation",
            "viewLinkedRequestForm",
            "editLinkedRequestForm"
        ]
    },

    Completeness: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",

            // letter access
            "actionCustomLetter",
            "actionCompletenessCorrectionEndedLetter",
            "actionContractTerminationLetter",
            "actionProlongationLetter",
            "viewSendLetterButton"
        ]
    },

    CompletenessCorrection: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRemarks",
            "viewRemarksNavigation",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewDeadlineExtendForm",
            "viewContractTerminationAgreement",

            // letter access
            "actionCustomLetter",
            "actionCompletenessCorrectionEndedLetter",
            "viewSendLetterButton",
        ]
    },

    CompletenessCorrectionEdit: {
        page: "/project",
        icon: "fa fa-pencil",
        anchor: "documents",
        permissionKeys: [
            "viewDefaultRequest",
            "editDefaultRequest",
            "viewRequestNavigation",
            "viewDocumentNavigation",
            "viewSaveButton",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewMultiFileUpload",
            "editMRA",

            // letter access
            "actionCustomLetter",
            "actionCompletenessCorrectionEndedLetter",
            "viewSendLetterButton",
        ]
    },

    CompletenessCorrectionCheck: {
        page: "/project",
        icon: "fa fa-pencil",
        anchor: "documents",
        permissionKeys: [
            "viewDefaultRequest",
            "viewRequestNavigation",
            "viewDocumentNavigation",
            "viewDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewPrintForm",
            "signPrintForm",
            "viewFormNavigation",
            "interactFormNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",

            // letter access
            "actionCustomLetter",
            "actionCompletenessCorrectionEndedLetter",
            "viewSendLetterButton"
        ]
    },

    SigningContract: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRemarks",
            "viewRemarksNavigation",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewDeadlineExtendForm",
            "viewContractTerminationAgreement",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton",
        ]
    },

    SigningContractInElectronicForm: {
        page: "/project",
        icon: "fa fa-envelope-o",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "activeContractDocuments",
            "activeDisputeProtocol",
            "viewDisputeProtocolBtn",
            "viewAlertWarningForSignContract",
            "editMRA",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton",
        ]
    },

    SigningContractInPaperForm: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewProjectProgressNavigation",
            "viewProjectProgress",
            "viewContractDocuments",
            "viewContractDocumentsNavigation",
            "viewPaperContractDocumentAlert",
            "viewPrevContractDocuments",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton"
        ]
    },

    SigningDisputes: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRemarks",
            "viewRemarksNavigation",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewDeadlineExtendForm",
            "viewContractTerminationAgreement",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton",
        ]
    },

    SigningDisputesInElectronicForm: {
        page: "/project",
        icon: "fa fa-envelope-o",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewDisputeProtocolBtn",
            "viewAlertWarningForSignContractAndSettlementProtocol",
            "activeContractDocuments",
            "activeDisputeProtocol",
            "editMRA",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton",
        ]
    },

    SigningDisputesInPaperForm: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewProjectProgressNavigation",
            "viewProjectProgress",
            "viewContractDocuments",
            "viewContractDocumentsNavigation",
            "viewPaperContractDisputeDocumentAlert",
            "viewPrevContractDocuments",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton"
        ]
    },

    SigningActInElectronicForm: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "activeActDocuments",
            "viewPrevContractDocuments",
            "viewAdditionalAgreements",
            "editMRA",
            "viewConclusionApplication",
            "viewConclusionApplicationNavigation",

            // letter access
            "actionCustomLetter",
            "contractDetailsChangedLetter",
            //"additionalAgreementLetter",
            "actionProlongationLetter",
            "viewSendLetterButton"
        ]
    },

    SigningActInPaperForm: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewPaperActDocumentAlert",
            "viewExtensionAgreementDocuments",
            "viewAdditionalAgreements",
            "viewConclusionApplication",
            "viewConclusionApplicationNavigation",

            // letter access
            "actionCustomLetter",
            "contractDetailsChangedLetter",
            //"additionalAgreementLetter",
            "actionProlongationLetter",
            "viewSendLetterButton"
        ]
    },

    SigningContractAgreementTerminationInPaperForm: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewContractTerminationAgreementAlert",
            "viewAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton"
        ]
    },

    SigningContractAgreementTerminationInElectronicForm: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "activeContractTerminationAgreement",
            "viewContractTerminationAgreement",
            "viewAdditionalAgreements",
            "editMRA",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton",
        ]
    },

    WaitingFinalPayment: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "contractDetailsChangedLetter",
            //"additionalAgreementLetter",
            "actionProlongationLetter",
            "viewSendLetterButton"
        ]
    },

    Examination: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "viewSendLetterButton"
        ]
    },

    WaitingForPayment: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            "viewSendLetterButton"
        ]
    },

    ContractConclusionConfirmation: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "viewSendLetterButton"
        ]
    },

    PrepareConclusion: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewExtensionAgreementDocuments",
            "activeExtensionAgreementDocuments",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            // letter access
            "actionCustomLetter",

            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",

            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton"
        ]
    },

    ConclusionIssued: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewAdditionalAgreements",
            "viewConclusionApplication",
            "viewConclusionApplicationNavigation",
            "viewExistConclusionApplication",
            "viewExistConclusionApplicationNavigation"
        ]
    },

  ServiceRendered: {
    page: "/project",
    icon: "",
    permissionKeys: [
      "viewRequestText",
      "viewRemarksNavigation",
      "viewRemarks",
      "viewTextRemarks",
      "viewSummaryRemarks",
      "viewDocument",
      "viewDocumentNavigation",
      "viewProjectProgress",
      "viewProjectProgressNavigation",
      "activeContractDocument",
      "viewContractDocumentsNavigation",
      "viewContractDocuments",
      "viewPrevContractDocuments",
      "viewAdditionalAgreements",
      "viewConclusionApplication",
      "viewConclusionApplicationNavigation",
      "viewExistConclusionApplication",
      "viewExistConclusionApplicationNavigation"
    ]
  },

    ExaminationCorrectionEdit: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewSummaryRemarks",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewSaveButton",
            "viewCorrectedTEPNavigation",
            "interactCorrectedTEPNavigation",
            "hideCopyTechIndicators",
            "viewCorrectedTEP",
            "editCorrectedTEP",
            "activeDeadlineExtendLetter",
            "viewMultiFileUpload",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",
            "viewExtensionAgreementDocuments",
            "activeExtensionAgreementDocuments",
            "editMRA",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter", // Расторжение договора
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "actionExtensionAgreementLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton",
        ]
    },

    ExaminationCorrectionCheck: {
        page: "/project",
        icon: "",
        anchor: "documentsPrintedForm",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewSummaryRemarks",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewCorrectedTEPNavigation",
            "interactCorrectedTEPNavigation",
            "viewCorrectedTEP",
            "viewDocumentsPrintedForm",
            "viewDocumentsPrintedFormNavigation",
            "activeDeadlineExtendLetter",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",
            "viewExtensionAgreementDocuments",
            "activeExtensionAgreementDocuments",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "actionExtensionAgreementLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton"
        ]
    },

    WithoutConsiderationRejection: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewSummaryRemarks",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
        ]
    },

    ContractTerminationInitiated: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewCorrectedTEPNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "viewSendLetterButton"
        ]
    },

    ExtendingDeadlineInitiated: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "interactCorrectedTEPNavigation",
            "viewCorrectedTEPNavigation",
            "hideCopyTechIndicators",
            "viewCorrectedTEP",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewDeadlineExtendForm",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",
            "viewExtensionAgreementDocuments",
            "activeExtensionAgreementDocuments",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "viewSendLetterButton"
        ]
    },
    ExtendingDeadlineInitiatedEdit: {
        page: '/project',
        icon: '',
        anchor: 'documentsPrintedForm',
        permissionKeys: [
            'viewRequestText',
            'viewDocumentNavigation',
            'viewDocument',
            'viewRemarksNavigation',
            'viewRemarks',
            'viewRemarksCENavigation',
            'viewRemarksCE',
            'viewRemarksCRNavigation',
            'viewRemarksCR',
            'viewSummaryRemarks',
            'viewProjectProgress',
            'viewProjectProgressNavigation',
            'viewContractDocumentsNavigation',
            'viewContractDocuments',
            'viewPrevContractDocuments',
            'viewCorrectedTEPNavigation',
            'interactCorrectedTEPNavigation',
            'viewCorrectedTEP',
            'viewDocumentsPrintedForm',
            'viewDocumentsPrintedFormNavigation',
            //"activeDeadlineExtendLetter",
            'viewAdditionalAgreements',
            'activeAdditionalAgreements',

            // letter access
            'actionCustomLetter',
            'actionEarlyTerminationOfESApplicationLetter',
            'actionContractDetailsChangedLetter',
            'actionNameChangedNoticeLetter',
            'actionCostChangedNoticeLetter',
            'actionContractTerminationLetter',
            //"actionAdditionalAgreementLetter",
            'actionProlongationLetter',
            'actionAgreementProlongationLetter',
            'actionTEPChangedLetter',
            'actionExtensionAgreementLetter',
            'actionRemarksAnswersLetter',
            'viewSendLetterButton',
        ],
    },

    ExtendingDeadlineInitiatedCheck: {
        page: '/project',
        icon: '',
        permissionKeys: [
            'viewRequestText',
            'viewRemarksNavigation',
            'viewRemarks',
            'viewRemarksCENavigation',
            'viewRemarksCE',
            'viewRemarksCRNavigation',
            'viewRemarksCR',
            'viewTextRemarks',
            'viewSummaryRemarks',
            'viewDocument',
            'editDocument',
            'signDocument',
            'viewDocumentNavigation',
            'viewProjectProgress',
            'viewProjectProgressNavigation',
            'activeContractDocument',
            'viewContractDocumentsNavigation',
            'viewContractDocuments',
            'viewPrevContractDocuments',
            'viewExtensionAgreementDocuments',
            'activeExtensionAgreementDocuments',
            'viewAdditionalAgreements',
            'activeAdditionalAgreements',

            // letter access
            'actionCustomLetter',
            'actionEarlyTerminationOfESApplicationLetter',
            'actionContractDetailsChangedLetter',
            'actionNameChangedNoticeLetter',
            'actionCostChangedNoticeLetter',
            'actionContractTerminationLetter',
            //"actionAdditionalAgreementLetter",
            'actionProlongationLetter',
            'actionAgreementProlongationLetter',
            'actionTEPChangedLetter',
            'actionRemarksAnswersLetter',
            'viewSendLetterButton',
        ],
    },

    SettlementDisputes: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",

            // letter access
            "actionCustomLetter",
            "viewPrevContractDocuments",
            "activeDeadlineExtendLetter",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            "actionAdditionalAgreementLetter",
            "actionTEPChangedLetter",
            "actionExtensionAgreementLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton"
        ]
    },

    CorrectionDeadlineExtended: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRemarks",
            "viewRemarksNavigation",
            "viewTextRemarks",
            "viewSummaryRemarks",
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "activeContractDocument",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewDeadlineExtendForm",
            "viewContractTerminationAgreement",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "actionExtensionAgreementLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton"
        ]
    },

    CorrectionDeadlineExtendedEdit: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "editDocument",
            "signDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewSummaryRemarks",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewSaveButton",
            "viewCorrectedTEPNavigation",
            "interactCorrectedTEPNavigation",
            "hideCopyTechIndicators",
            "viewCorrectedTEP",
            "editCorrectedTEP",
            "editMRA",
            //"activeDeadlineExtendLetter",
            "viewExtensionAgreementDocuments",
            "activeExtensionAgreementDocuments",
            "viewMultiFileUpload",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "actionExtensionAgreementLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton"
        ]
    },

    CorrectionDeadlineExtendedCheck: {
        page: "/project",
        icon: "",
        anchor: "documentsPrintedForm",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewSummaryRemarks",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewCorrectedTEPNavigation",
            "interactCorrectedTEPNavigation",
            "viewCorrectedTEP",
            "viewDocumentsPrintedForm",
            "viewDocumentsPrintedFormNavigation",
            //"activeDeadlineExtendLetter",
            "viewAdditionalAgreements",
            "activeAdditionalAgreements",

            // letter access
            "actionCustomLetter",
            "actionContractDetailsChangedLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "actionExtensionAgreementLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton"
        ]
    },

    CorrectionDeadlineExtendedWaiting: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocumentNavigation",
            "viewDocument",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewSummaryRemarks",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewCorrectedTEPNavigation",
            "interactCorrectedTEPNavigation",
            "viewCorrectedTEP",
            "viewDocumentsPrintedForm",
            "viewDocumentsPrintedFormNavigation",
            "viewExtensionAgreementDocuments",
            "activeExtensionAgreementDocuments",

            // letter access
            "actionCustomLetter",
            "actionNameChangedNoticeLetter",
            "actionCostChangedNoticeLetter",
            "actionContractTerminationLetter",
            //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            "actionTEPChangedLetter",
            "actionExtensionAgreementLetter",
            "actionRemarksAnswersLetter",
            "viewSendLetterButton"
        ]
    },

    ViolationSigningContractDeadlineRejection: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewRemarksNavigation",
            "viewRemarks"
        ]
    },

    ViolationSigningDisputesDeadlineRejection: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments",
            "viewRemarksNavigation",
            "viewRemarks"
        ]
    },

    ViolationCorrectionDeadlineRejection: {
        page: "/project",
        icon: "",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewRemarksNavigation",
            "viewRemarks",
            "viewTextRemarks",
            "viewAdditionalAgreements"
        ]
    },

    ContractCanceled: {
        page: "/project",
        icon: "fa fa-envelope-o",
        permissionKeys: [
            "viewRequestText",
            "viewDocument",
            "viewDocumentNavigation",
            "viewProjectProgress",
            "viewProjectProgressNavigation",
            "viewContractDocumentsNavigation",
            "viewContractDocuments",
            "viewPrevContractDocuments"
        ]
    },

    WaitingForExpertSupportRequest: {
        page: '/project',
        icon: '',
        permissionKeys: [
            'viewRequestText',
            'viewDocument',
            'editDocument',
            'signDocument',
            'viewDocumentNavigation',
            'viewProjectProgress',
            'viewProjectProgressNavigation',
            'activeContractDocument',
            'viewContractDocumentsNavigation',
            'viewContractDocuments',
            'viewPrevContractDocuments',
            'viewAdditionalAgreements',
            'activeAdditionalAgreements',
            'viewRemarksCENavigation',
            'viewRemarksCE',
            'viewRemarksCRNavigation',
            'viewRemarksCR',
            'viewContractTerminationAgreement',
            'activeContractTerminationAgreement',

            // letter access
            'actionCustomLetter',
            'actionNameChangedNoticeLetter',
            'actionCostChangedNoticeLetter',
            'actionCompletionLetterEs',
            "actionContractTerminationLetter",
          //"actionAdditionalAgreementLetter",
            "actionProlongationLetter",
            'viewSendLetterButton',
        ],
    },

    new: {
        page: "/new",
        icon: "fa fa-pencil",
        anchor: null,
        permissionKeys: []
    },

    default: {
        page: "/project",
        icon: "fa fa-pencil",
        anchor: null,
        permissionKeys: []
    }
};


Object.keys( stages )
    .map((key) => stages[key] )
    .filter((item)=> item.stages)
    .forEach((stage) => {
        let copyStage = stage.stages

        delete stage.stages
        copyStage.forEach((stageKey) => (stages[ stageKey ] = stage ))
    })

export { stages }



// WEBPACK FOOTER //
// client/config/stages.es6